import types from "./types";

const initialState = {
  certificateData: {},
  certificationsList: [],
  singleCertification: {},
  popularCertifications: {},
  globalSearchCertificates: {},
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action) => {
  // console.log("Reducer certificate new one", action.payload, action.type);
  switch (action.type) {
    case types.CERTIFICATE_DATA_RESPONSE:
      return {
        ...state,
        certificateData: action.payload,
      };
    case types.CERTIFICATE_DATA_CLEAR:
      return {
        ...state,
        certificateData: {},
      };
    case types.GET_ALL_CERTIFICATIONS_RES:
      return {
        ...state,
        certificationsList: action.payload,
      };
    case types.GET_ALL_CERTIFICATIONS_CLEAR:
      return {
        ...state,
        certificationsList: [],
      };
    case types.GET_SINGLE_CERTIFICATIONS_RES:
      return {
        ...state,
        singleCertification: action.payload,
      };
    case types.GET_SINGLE_CERTIFICATIONS_CLEAR:
      return {
        ...state,
        singleCertification: {},
      };
    case types.GET_POPULAR_CERTIFICATIONS_RES:
      return {
        ...state,
        popularCertifications: action.payload,
      };
    case types.GET_POPULAR_CERTIFICATIONS_CLEAR:
      return {
        ...state,
        popularCertifications: {},
      };
    case types.GLOBAL_SEARCH_CERTIFICATES_RESPONSE:
      return {
        ...state,
        globalSearchCertificates: action.payload,
      };
    case types.GLOBAL_SEARCH_CERTIFICATES_CLEAR:
      return {
        ...state,
        globalSearchCertificates: {},
      };
    default:
      return state;
  }
};
